import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconHeartActiveSvg } from "./IconHeartActiveSvg.mjs";
import { IconHeartSvg } from "./IconHeartSvg.mjs";
const IconHeart = ({ active = false, ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: active ? IconHeartActiveSvg : IconHeartSvg,
    ...svgProps
  }
) });
export {
  IconHeart
};
